import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { IoCloseSharp, BsImages } from "../../components/utils/icons";
import { useStateContext } from "../../context/ContextProvider";
import { EditTextQill } from "./utils";
import { DLabel, DSpinButton } from "../utils/Form";
import { toast } from "react-toastify";
import { Loader } from "../utils";
import { useParams } from "react-router-dom";
import { BaseUrl, media } from "../../server";
import { getCategory } from "../../redux/actions/category";
import { getServices } from "../../redux/actions/services";
function EditService() {
  const { t } = useTranslation();
  const { currentColor } = useStateContext();
  const dispatch = useDispatch();
  const [isSpinner, setIsSpinner] = useState(false);
  const { id } = useParams();
  useEffect(() => {
    dispatch(getServices(id));
  }, [dispatch, id]);
  const { servicesData, isLoading } = useSelector((state) => state.Services);
  const [titleAr, setTitleAr] = useState(servicesData?.titleAr);
  const [titleEn, setTitleEn] = useState(servicesData?.titleEn);
  const [textEn, setTextEn] = useState(servicesData?.textEn);
  const [textAr, setTextAr] = useState(servicesData?.textAr);
  const [image, setImage] = useState(servicesData?.Image);
  const [icon , setIcon]=useState(servicesData?.icon)
  const [iconShow , setIconShow]=useState({ url: `${media}${servicesData?.icon}`})
  const [imageShow, setImageShow] = useState({
    url: `${media}${servicesData?.Image}`,
  });

  useEffect(() => {
    if (servicesData) {
      setTitleAr(servicesData.titleAr);
      setTitleEn(servicesData.titleEn);
      setTextEn(servicesData.textEn);
      setTextAr(servicesData.textAr);
      setImage(servicesData.Image);
      setIcon(servicesData.icon)
      setImageShow({ url: `${media}${servicesData.Image}` });
      setIconShow({ url: `${media}${servicesData.icon}` });
    }
    
  }, [servicesData]);

  const inmageHandle = (e) => {
    const file = e.target.files[0];

    if (file) {
      setImage(file);
      const imageUrl = { url: URL.createObjectURL(file) }; // كائن مباشر
      setImageShow(imageUrl);
    }
  };
  const iconHandle = (e) => {
    const file = e.target.files[0];

    if (file) {
      setIcon(file);
      const IconUrl = { url: URL.createObjectURL(file) }; // كائن مباشر
      setIconShow(IconUrl);
    }
  };
  const changeIcon = (icon) => {
    if (icon) {
      const tempUrl = { url: URL.createObjectURL(icon) }; // كائن مباشر
      setIconShow(tempUrl);
      setIcon(icon);
    }
  };
  const removeIcon = () => {
    setIcon();
    setIconShow();
  };

  const changeImage = (img) => {
    if (img) {
      const tempUrl = { url: URL.createObjectURL(img) }; // كائن مباشر
      setImageShow(tempUrl);
      setImage(img);
    }
  };

  const removeImage = () => {
    setImage();
    setImageShow();
  };

  const UpdateService = async (newForm) => {
    try {
      const config = { headers: { "Content-Type": "multipart/form-data" } ,withCredentials: true  };
      const { data } = await axios.put(
        `${BaseUrl}/services/${id}`,
        newForm,
        config
        ,  
      );
if(data.success){
      // عرض رسالة نجاح
      toast.success(
        <span className="font-kufi text-tcolor-4 dark:text-tcolor-1 text-sm">
          {t("Practice updated successfully!")}
        </span>
      );

      // إعادة تعيين الحالات
      setIsSpinner(false);}
    } catch (error) {
      // عرض رسالة خطأ
      toast.error(error.response?.data?.message);
      setIsSpinner(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSpinner(true);
    const newForm = new FormData();
    // إضافة الصورة فقط إذا كانت موجودة وتم تغييرها
    if (image instanceof File) {
      newForm.append("image", image);
    }
    if (icon instanceof File) {
      newForm.append("icon", icon);
    }
    newForm.append("titleAr", titleAr);
    newForm.append("titleEn", titleEn);
    newForm.append("textAr", textAr);
    newForm.append("textEn", textEn);

    UpdateService(newForm);
  };

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="w-[90%] bg-back-primery lg:w-[50%] m-2 md:m-10 mt-24 p-2 md:p-10  rounded-3xl">
          <h3 className="text-xl font-semibold text-color-1 font-kufi color text-center">
            {t( "Edit Practice")}
          </h3>
          <form onSubmit={handleSubmit}>
            <br />
            <div>
              <DLabel
                labelText="Title (Ar)"
                value={titleAr}
                onChange={(e) => {
                  setTitleAr(e.target.value);
                }}
                required={false}
                type="text"
                name="titleAr"
              />
              <DLabel
                labelText="Title (En)"
                value={titleEn}
                onChange={(e) => {
                  setTitleEn(e.target.value);
                }}
                required={false}
                type="text"
                name="titleAr"
              />

              <div className="relative flex-col items-center  mb-4 h-auto pb-5">
                <label className="pb-2 text-tcolor-5  text-md font-kufi">
                  {" "}
                  {t("Write the Text (Ar)")}
                </label>{" "}
                <EditTextQill text={textAr} setText={setTextAr} />
              </div>

              <div className="relative flex-col items-center  mb-4 h-auto pb-5">
                <label className="pb-2 text-tcolor-5 text-md font-kufi">
                  {" "}
                  {t("Write the Text (En)")}
                </label>{" "}
                <EditTextQill text={textEn} setText={setTextEn} />
              </div>
              <label className="pb-2 text-tcolor-5  text-md font-kufi">
                {t("Upload Image")}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name=""
                id="upload"
                className="hidden"
                onChange={inmageHandle}
              />

              {imageShow ? (
                <div className="h-[180px] relative">
                  <label htmlFor="0">
                    <img
                      className="w-full h-full rounded-lg border"
                      src={imageShow.url} // الوصول إلى url مباشرةً
                      alt=""
                      style={{
                        borderColor: currentColor,
                      }}
                    />
                  </label>
                  <input
                    onChange={(e) => changeImage(e.target.files[0])}
                    type="file"
                    id="0"
                    className="hidden"
                  />
                  <span
                    onClick={removeImage}
                    className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
                    style={{ backgroundColor: currentColor }}
                  >
                    <IoCloseSharp />
                  </span>
                </div>
              ) : (
                <label
                  className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
                  htmlFor="image"
                  style={{
                    borderColor: currentColor,
                  }}
                >
                  <span>
                    <BsImages size={40} color={currentColor} />
                  </span>
                  <span
                    className=" text font-kufi text-md"
                    style={{
                      color: currentColor,
                    }}
                  >
                    {t("Select Image")}
                  </span>
                </label>
              )}






<label className="pb-2 text-tcolor-5  text-md font-kufi">
                {t("Upload Icon")}
                <span className="text-red-500">*</span>
              </label>
              <input
                type="file"
                name=""
                id="icon-upload"
                className="hidden"
                onChange={iconHandle}
              />
{iconShow ? (
  <div className="h-[180px] relative">
    <label htmlFor="icon-upload">
      <img
        className="w-full h-full rounded-lg border"
        src={iconShow.url}
        alt="Icon"
        style={{ borderColor: currentColor }}
      />
    </label>
    <input
      onChange={(e) => changeIcon(e.target.files[0])} // تصحيح إلى files[0]
      type="file"
      id="icon-upload" // معرف فريد
      className="hidden"
    />
    <span
      onClick={removeIcon}
      className="p-2 z-10 cursor-pointer hover:shadow-lg hover text-white absolute top-1 right-1 rounded-full"
      style={{ backgroundColor: currentColor }}
    >
      <IoCloseSharp />
    </span>
  </div>
) : (
  <label
    className="flex mt-2 justify-center items-center flex-col h-[180px] cursor-pointer border rounded-lg border-dashed hover:border-indigo-500 w-full text-[#d0d2d6]"
    htmlFor="icon-upload" // مطابقة مع المعرف الجديد
    style={{ borderColor: currentColor }}
  >
    <span><BsImages size={40} color={currentColor} /></span>
    <span className="text font-kufi text-md" style={{ color: currentColor }}>
      {t("Select Icon")}
    </span>
  </label>
)}


              <input
                onChange={iconHandle}
                className="hidden"
                type="file"
                id="icon-upload"
              />
              <br />
            </div>
            <DSpinButton isLoading={isSpinner}>{t("Edit")}</DSpinButton>
          </form>
        </div>
      )}
    </>
  );
}

export default EditService;
